const config = {
  //apiUrl: "http://127.0.0.1:5000"
  apiUrl: "https://asuka-api-489350944755.us-central1.run.app"
};

export default config;
